import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  // Domyslnie jasny dla nowych odwiedzajacych (21.07, decyzja Marcina dla publicznych stron).
  // WAZNE (26.07, fix hydratacji #418/#423/#425): initial state jest ZAWSZE 'light', NIGDY nie
  // czyta localStorage synchronicznie przy pierwszym renderze - react-snap prerenderuje kazda
  // strone z pustym localStorage (zawsze 'light'), wiec pierwszy render klienta MUSI dac ten sam
  // wynik co zamrozony HTML, inaczej hydratacja peka (theme jest czytany SYNCHRONICZNIE w renderze
  // przez PublicNavBar/LogoG1/LoginScreen - LogoG1 renderuje inne poddrzewo SVG dla dark mode).
  // Prawdziwa zapisana preferencja wczytywana DOPIERO w useEffect ponizej, po hydratacji - ten sam
  // wzorzec co iso_lang w PrivacyPage.jsx.
  // Klucz zmieniony 11.08 z iso_theme na ga_theme przy budowie ciemnego motywu dla stron
  // publicznych Gap Assessment - w tamtym momencie ten kontekst byl jeszcze niezuzywany przez
  // zadna z 6 stron, wiec rename byl bezpieczny (zero istniejacych zapisanych wartosci do migracji).
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const stored = localStorage.getItem('ga_theme');
    if (stored && stored !== 'light') setTheme(stored);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('ga_theme', theme);
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) favicon.href = theme === 'light' ? '/favicon-light.svg' : '/favicon-dark.svg';
  }, [theme]);

  const toggleTheme = () => setTheme(t => (t === 'dark' ? 'light' : 'dark'));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
